import React, {Component} from 'react';
import Template from '../Template';
import CdpPay from '../../components/CdpPay';

export default class SavedPayCalendar extends Component {
    render() {
        return (<Template activeLink='cdp'>
            <CdpPay {...this.props} saved={true}/>
        </Template>);
    }
}
